import { Navigate } from 'react-router';
import { useSelector } from '../redux/store';
import type { RootState } from '../redux/store';
import { PATH_DASHBOARD, PATH_ORG } from './paths';

/**
 * The active org persists in localStorage across sessions, so a cold launch
 * (e.g. PWA home-screen start) can land on /dashboard while an org is still
 * active — showing the personal overview under an org sidebar. Route the
 * index redirect to whichever overview matches the restored context.
 */
export default function ContextAwareOverviewRedirect() {
  const activeOrgGuid = useSelector((s: RootState) => s.organizationContext.activeOrgGuid);

  return <Navigate to={activeOrgGuid ? PATH_ORG.overview : PATH_DASHBOARD.overview.root} replace />;
}
